class VideoPlayPause {
  
  constructor( div ) {
    this.div = div;
    this.bottomRootMargin = $( window ).height() > $( window ).width() ? '-8%' : '-20%';
  }

  init() {
    const observer = new IntersectionObserver(
      ( entries ) => {
        entries.forEach( ( entry ) => {
          const div = $( entry.target );
          const iframe = div.find( '.embed-responsive-item' );
          const html5Video = div.find( 'video' );
          if ( !entry.isIntersecting ) {
            if ( iframe.length !== 0 ) {
              this.pauseIframeVideo( iframe );
            } else if ( html5Video.length !== 0 ) {
              this.pauseHTML5Video( html5Video );
            }
          } else {
            if ( html5Video.length !== 0 && html5Video[0].autoplay ) {
              this.playHTML5Video( html5Video );
            }
          }
        } );
      },
      {
        root: null,
        rootMargin: '0px 0px ' + this.bottomRootMargin + ' 0px',
        threshold: [0.25],
      }
    );

    observer.observe( this.div );
    const $div = $( this.div );
    const playButton = $div.find( '.play-button' );
    const iframe = $div.find( '.embed-responsive-item' );

    playButton.on( 'click', () => {
      this.playIframeVideo( iframe );
      iframe.show();
    } );
  }
  
  pauseIframeVideo( iframe ) {
    const iframeContent = iframe[0].contentWindow;
    iframeContent.postMessage(
      JSON.stringify( { event: 'command', func: 'pauseVideo' } ),
      '*'
    );
  }

  pauseHTML5Video ( video ) {
    video.get( 0 ).pause();
  }

  playHTML5Video ( video ) {
    video.get( 0 ).play();
  }

  playIframeVideo( iframe, mute = false, controls = true ) {
    const $src = iframe.attr( 'src' );
    const $domainSrc = $src.indexOf( '?' ) !== -1 ? $src.split( '?' )[0] : $src;
    const mText = `mute=${mute ? '1' : '0'}`;
    const cText = controls ? '' : '&controls=0';
    const $updSrc = `${$domainSrc}?enablejsapi=1&${mText}&autoplay=1&modestbranding=1&playsinline=1&rel=0` + cText;
    setTimeout( function () {
      iframe.attr( 'src', $updSrc );
    }, 50 );
  }

}


$( ( $ ) => {

  const divs = $( '.bs-section--standard-knowledge-banner-media, .bs-div--blog-standard-inner-media-block' );
  if ( divs.length === 0 ) return;

  divs.each( ( i, div ) => {
    const videoPlayPause = new VideoPlayPause( div );
    videoPlayPause.init();
  } );

} );